import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";
import { toast } from "react-toastify";

const initialState = {
    inboxData: [],
    pagination: null,
    loading: false,
    error: null,
};

export const getMccBlockManagementInboxData = createAsyncThunk(
    "mcc-block-management/inbox",
    async ({ user, pagination }, thunkAPI) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const isMaker = window?.location?.pathname?.includes('maker');
            const isChecker = window?.location?.pathname?.includes('checker');

            let apiURL;

            if (isMaker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.getMakerPendingBlockedMcc;
                apiURL = base + endpointpath + `/${pagination.pageSize}/${pagination.currentPage}`;

            } else if (isChecker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.getCheckerPendingBlockMcc;
                apiURL = base + endpointpath + `/${pagination.pageSize}/${pagination.currentPage}`;
            } else {
                return thunkAPI.rejectWithValue({ skip: true });
            }

            const response = await axiosInstance.get(apiURL);
            return response?.data;
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

export const postAddedUpdateMcctReview = createAsyncThunk(
    "mcc-block-management/inbox/added-update-mcc-review",
    async ({ user, body }, thunkAPI) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const isMaker = window?.location?.pathname?.includes('maker');
            const isChecker = window?.location?.pathname?.includes('checker');

            let apiURL;

            if (isMaker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.updatemccmakerreviewtasks;
                apiURL = base + endpointpath;

            } else if (isChecker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.addBlockedMccReviewTasks;
                apiURL = base + endpointpath;
            } else {
                return thunkAPI.rejectWithValue({ skip: true });
            }

            const response = await axiosInstance.post(apiURL, body);

            if (response?.data?.responseCode === '400' || response?.data?.responseCode === '409') {
                toast.error(response?.data?.responseDescription);
                return { status: response?.data?.responseCode };
            }

            toast.success(body.isaccepted ? 'Request accepted and send successfully' : 'Request rejected and send successfully');
            return { ...response?.data, status: response.status };
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

const MccBlockManagementInboxSlice = createSlice({
    name: "mcc-block-management-inbox",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // GET ALL BLOCK MCC
            .addCase(getMccBlockManagementInboxData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getMccBlockManagementInboxData.fulfilled, (state, action) => {
                const { data, currentPage, pageSize, totalItem, totalPages } = action?.payload;
                state.loading = false;
                state.inboxData = data || [];
                state.pagination = { currentPage, pageSize, totalItem, totalPages }
            })
            .addCase(getMccBlockManagementInboxData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // ADD UPDATE MCC REVIEW
            .addCase(postAddedUpdateMcctReview.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(postAddedUpdateMcctReview.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(postAddedUpdateMcctReview.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default MccBlockManagementInboxSlice.reducer;